export default function AboutHero() {
  return (
    <section className="relative overflow-hidden bg-gray-950 py-24 md:py-32">
      {/* Decorative shapes */}
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-green-600/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-20 h-72 w-72 rounded-full bg-green-500/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="mb-4 inline-block text-sm font-semibold text-green-400">
            من نحن
          </span>

          <h1 className="text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
            خبراء في التدوير
            <span className="mt-2 block text-green-400">
              نصنع أثرًا مستدامًا
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-gray-300 md:text-lg">
            نعمل على تقديم حلول عملية وفعالة لإدارة المواد القابلة لإعادة
            التدوير، من الجمع والاستلام وحتى الفرز والتجهيز وإعادة التدوير.
          </p>
        </div>
      </div>
    </section>
  );
}